import { createBrowserRouter } from "react-router-dom";
import App from "../../App";
import Login from "../../pages/login";
import ChangePassword from "../../pages/changePassword";
import Voucher from "../../pages/voucher";

export const router = createBrowserRouter([
    {
      path: "/",
      element: <App Component={Voucher} />,
    },
    {
      path: "/login",
      element: <App Component={Login} />,
    },
    {
      path: "/changePassword",
      element: <App Component={ChangePassword} />,
    }
  ]);